import { render } from "./EditInvoicePage.vue?vue&type=template&id=b57dfa08&ts=true"
import script from "./EditInvoicePage.vue?vue&type=script&lang=ts"
export * from "./EditInvoicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__